
import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import Adminheader from './Adminheader';
import Adminsidebar from './Adminsidebar';
import favicon from "../../images/chainpad/logo.png"
import { Dropdown, Nav, Tab, Row, Col, Container, ProgressBar, InputGroup,Form } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { getPropsals } from '../../hooks/useVoting';



class Proposal extends Component {

     showLoader()
  {
    document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 0.5;
    document.getElementById("loader_div").classList.remove("d-none");
    document.getElementById("loader_div").classList.add("d-block");


  }

  hideLoader()
  {
    document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 1;
    document.getElementById("loader_div").classList.remove("d-block");
    document.getElementById("loader_div").classList.add("d-none");
  }


   componentDidMount()
    {
     this.hideLoader();
     this.getproposallist()
     
    }

   async getproposallist() {
    try{
    console.log("resssdgdfg");
       let res = await getPropsals()
       console.log("resssdgdfg",res);
       this.setState({currentproposal : res})
    }
    catch(error){
         console.log("getproposallist_errr",error);
    }

       
   } 

    constructor(props) {
    super(props);
    this.state = {
         currentproposal: [],
        };
  }


    render() {



         return (

              <div id="loader_main">
        <div id="loader_div">
          <span className="spin_round">

          </span>
          <img src={favicon} className="logo_load" />
        </div>

        <div className='logo_overlay' id="logo_overlay">
            <Adminheader />

              <div className="whole_sec pb-5">
            <div className='flex_side_right adminisideright'>
                <Adminsidebar />

                <div className='right_side_sec adminside'>
                  
                   <div className="right_side_spacing">

<div className='ongoing_sec proj_bg pb-5'>

<div className="container px-1">
     <div className='top_heqad_sec mt-5 mt-md-0'>
        <div className="row">
            <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                 <p className="banner_subtitle form_subhead">Voting</p>

            </div>
        </div>
     </div>
</div>


<div className="inner_bg">
    <div className="container px-1">
        <Tab.Container  defaultActiveKey="second">
            <Row className="container-fluid w-100 mx-0 px-0">
                <Col lg={12} className="img_center_lg px-0">
                {/* container container_custom px-0 */}
                <div className=''>
                    <Tab.Content>
                        <Tab.Pane eventKey="second">
                             <div class="table-responsive">
                                   {this.state.currentproposal && this.state.currentproposal.length > 0 ?
                                <table className="table recepients_table">
                                  <thead>
                                    <tr>
                                        <th>Pid</th>
                                        <th>Title</th>
                                         <th>TitleSlug</th>
                                         <th>Status</th>
                                         <th>Start Date</th>
                                         <th>End Date</th>
                                         <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                     {this.state.currentproposal &&  this.state.currentproposal.length > 0 && this.state.currentproposal?.map((data , i)=><>
                                     <tr>
                                        <td>{data._pid}</td>
                                        <td>{data.title}</td>
                                        <td>{data.title_slug}</td>
                                        <td>{data?.status == 0 ? "Pending" : data?.status == 1 ? "Approved" : data?.status == 2 && "Finalized"}</td>
                                        <td>{new Date(parseInt(data?.startDate) * 10000).toLocaleString()}</td>
                                        <td>{new Date(parseInt(data?.endDate) * 10000).toLocaleString()}</td>
                                        <td><Link className='link_text' onClick={() => this.props.history.push("/votingedit", { state: data })}>Edit</Link></td>
                                     </tr>
                                     </>
                                     )}
                                  </tbody>  
                                </table>
                              : <p className='no_data_text'>No Data Found</p> }
                             </div>
                        </Tab.Pane>
                    </Tab.Content>
                </div>
                </Col>
            </Row>
        </Tab.Container>
    </div>
</div>


</div>

                   </div>

                </div>

            </div>

            </div>

        </div>

         </div>
    )
  }
}

export default Proposal



